import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, styled, Text } from 'shell/components';

const AssignmentImportSection = memo(({ disabled = false, onImport }) => {
    const { t } = useTranslation('assignment');

    return (
        <RootStack spacing={2}>
            <Text variant={'p1'}>{t('assignment-rollover.section-title', 'Import Assignment Settings')}</Text>
            <Stack alignItems={'center'} direction={'row'} flexWrap={'wrap'} spacing={3}>
                <Text color={'light'}>
                    {t('assignment-rollover.section-description', 'Reuse settings from another assignment')}
                </Text>
                <Button disabled={disabled} variant={'secondary'} onClick={onImport}>
                    {t('common:controls.import', 'Import')}
                </Button>
            </Stack>
        </RootStack>
    );
});

const RootStack = styled(Stack)(() => ({
    width: '100%',
}));

export default AssignmentImportSection;
